import type { KeyboardEvent } from 'react';

export const onEnterOrSpaceKeyPress = (event: KeyboardEvent, fn: () => void) => {
  event.preventDefault();
  if (event.key === 'Enter' || event.key === ' ') {
    fn();
  }
};

export const preventSubmit = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
};
